module.exports = __webpack_public_path__ + "bed778f56c16ff41bf0638763304f61b.svg";